const CONST = {
	CONTENT_MARGIN: 16,
	MODAL_CONFIRM_WIDTH: 550,

	B2C_GROUP_ID: 99999,

	MI_COMPANY_ID: 2,
	MI_SALES_COMPANY_ID: 4
};
export default CONST;
